<template>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="card">
                <div class="card-header">Bem-vindo</div>

                <div class="card-body">
                    <img src="https://contasmoradores.candido.org.br/storage/grafico.png" width="100%">
                    <img src="https://contasmoradores.candido.org.br/storage/atualizacao1.png" width="100%">
                    <img src="https://contasmoradores.candido.org.br/storage/atualizacao.png" width="100%">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
    }
</script>
